var _style, _path, _path2, _g, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg360 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st1 {\n\t\t\tfill: none;\n\t\t\tstroke: #929993!important;\n\t\t\tstroke-width: 26.8104;\n\t\t\tstroke-miterlimit: 10;\n\t\t}\n\n\t\t.st2 {\n\t\t\tstroke-width: 1.0408;\n\t\t\tstroke-miterlimit: 10;\n\t\t}\n\n\t\t.st3 {\n\t\t\tfill: none;\n\t\t\tstroke-width: 14.1732;\n\t\t\tstroke-miterlimit: 10;\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.3,75.9c61,0,110.5,119.9,110.5,267.7s-49.5,267.7-110.5,267.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.9,276.3c54.3-14.2,125.9-22.8,204.4-22.8c169.7,0,307.2,40.4,307.2,90.1s-137.5,90.1-307.2,90.1 S49.1,393.4,49.1,343.6c0-23.6,31-45.1,81.6-61.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2 text-fill text-stroke",
    d: "M155.7,387.5l13.8-14.3c2.4-2.3,4.9-2.3,7,0c0.8,1.2,16.7,15.8,33.2,15.8c14.6,0,28.6-11.4,28.6-27.5 c0-15.2-12.9-28.9-37.2-28.9h-15.1c-3,0-5.1-2.3-5.1-5.8v-18.4c0-3.8,1.9-5.8,5.1-5.8H201c22.1,0,33.4-12,33.4-26.9 c0-16.1-12.4-26.9-26.2-26.9c-14,0-22.7,8.2-27.2,14c-1.9,2.3-4.9,2.6-7.3,0.3l-13.2-13.4c-2.2-2-1.9-5.6,0-7.6 c0,0,20.5-25.7,50.7-25.7c31.3,0,57.5,20.7,57.5,53.5c0,22.5-15.6,39.4-27.8,45.6v0.9c12.7,5.8,32.6,21.6,32.6,47.6 c0,33-24.8,57-62,57c-33.7,0-50.2-18.4-56.1-26C153.8,392.8,154,389.6,155.7,387.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2 text-fill text-stroke",
    d: "M374.9,212.8c3.8-1.2,6.5,0.3,7.6,4.1l6.2,17.2c1.3,3.5,0.3,6.7-4.9,8.5c-12.7,4.4-51,24-59.3,56.1 c4.6-2.9,18.1-8.2,30.8-8.2c27,0,55,21.6,55,63.4c0,36.8-27.8,66.9-61,66.9c-42.3,0-64.2-36.8-64.2-80.6 C285.1,254.9,351.7,221,374.9,212.8z M379.8,353.3c0-18.7-13.8-34.2-31-34.2c-17.8,0-28.3,14.9-31.3,25.4 c0,19.9,9.7,42.9,31.6,42.9C366,387.5,379.8,371.7,379.8,353.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2 text-fill text-stroke",
    d: "M420.3,318.6c0-64,24.8-102.3,68-102.3c43.2,0,68,38.3,68,102.3c0,64-24.8,102.3-68,102.3 C445.1,420.8,420.3,382.6,420.3,318.6z M520.9,318.6c0-43.2-11.9-67.8-32.6-67.8c-20.8,0-32.6,24.5-32.6,67.8 c0,43.5,11.9,67.8,32.6,67.8C509.1,386.3,520.9,362.1,520.9,318.6z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.8,465.2c-7.7-36.5-12-77.8-12-121.6c0-147.9,49.5-267.7,110.5-267.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.3,611.4c-39.1,0-73.5-49.2-93.1-123.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3 text-stroke",
    cx: 583.4,
    cy: 243.9,
    r: 21.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M663.5,343.6c0,49.8-137.5,90.1-307.2,90.1S49.1,393.4,49.1,343.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.5,279c0,0,27.7,19.2,55.1,8.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.9,339.1c0,0-4-33.5,18.3-52.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.8,546.3c0,0,24.1-23.6,18.7-52.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.5,518.1c0,0-33.6-2.4-48.2-28"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg360);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "360.9d220a84414f6724aac2d9b1fa2b5714.svg";